import { z } from 'zod';
import { envInfoSchema } from '@orionprotocol/common';
import { SupportedChainId, utils } from '@orionprotocol/sdk';

const { isValidChainId } = utils;

export function isChainInCurrentEnvironment(
  envs: Partial<Record<string, z.infer<typeof envInfoSchema>>>,
  env: string,
  chId: string,
): chId is SupportedChainId {
  const envInfo = envs[env];
  if (!envInfo) return false;
  return Object.keys(envInfo.networks)
    .filter(isValidChainId)
    .some((chainId) => chainId === chId);
}
